import { QueryConfig } from "store/utils/query-config";

export const screenToursDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
